// extracted by mini-css-extract-plugin
export default {"title":"ChangePassword_title__6xkJc","link":"ChangePassword_link__S0pSi"};